import { Base } from './base.model';

export class LegalPage extends Base {
  name: string;
  version: number;
  pageHtml: string;
}
